import { Box, SxProps, Theme } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';
import classNames from 'classnames';
import React from 'react';

export interface ConfigurationCanvasPanelProps {
  children: React.ReactNode | React.ReactNode;
  width?: number;
  sx?: SxProps<Theme>;
  skipSizeAllocation?: boolean;
  isExpandedMode?: boolean;
  id?: string;
}

export const ConfigurationCanvasPanel = ({
  children,
  width,
  sx,
  positionSx,
  isExpandedMode,
  id,
}: ConfigurationCanvasPanelProps & { positionSx?: SxProps<Theme> }) => {
  const _sx = { ...positionSx, ...sx };
  return (
    <Box
      sx={{
        width: isExpandedMode ? '100%' : `${width}px`,
        transition: '1s width',
        margin: '0',
        height: '100%',
        maxHeight: '100vh',
        boxShadow: 1,
        zIndex: 1001, //Above CanvasToolbar (1000)
        padding: isExpandedMode ? '32px 0 0' : '16px 0 0',
        background: colors.white,
        display: 'flex',
        flexDirection: 'column',
        //THIS PANEL CANNOT HAVE OVERFLOW HIDDEN - THEY MIGHT BE ITEMS OPENED WITH POSITION ABSOLUTE IN IT
        //overflow: 'hidden',
        gap: isExpandedMode ? 3 : 2,
        flexWrap: 'nowrap',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        alignContent: 'stretch',
        ..._sx,
      }}
      className={classNames({
        'configuration-canvas-panel': true,
        'configuration-canvas-panel-expanded': isExpandedMode,
      })}
      id={id}
    >
      {children}
    </Box>
  );
};
